import {
  deleteExternalCalendarEvent as _deleteExternalCalendarEvent,
  DeleteExternalCalendarEventResult,
} from '@griply/services';
import { DeleteCalendarEventInput } from '@griply/types';
import { httpsCallable } from 'firebase/functions';

import { getFunctions } from './helpers';
import { reportUnknownCalendarEventError } from './helpers/report-unknown-calendar-event-error';

export const deleteExternalCalendarEvent = async (
  payload: DeleteCalendarEventInput,
): Promise<DeleteExternalCalendarEventResult> => {
  try {
    return await _deleteExternalCalendarEvent({
      functions: getFunctions(),
      httpsCallable,
      payload,
    });
  } catch (error: unknown) {
    reportUnknownCalendarEventError(error, 'external-calendars-delete-event');
    throw error;
  }
};
